import Styles from './ChatMessages.module.scss'
import cx from 'classnames'
import { Skeleton } from 'antd'
import { LoadingStateProps } from './Types'

const LoadingUserMessage = () => (
  <div className={cx(Styles.loadingMessage, Styles.user)} data-testid="loading-user-message">
    <Skeleton
      active
      title={{ width: '90%', style: { height: '17px', borderRadius: '29px', margin: 0, padding: 0 } }}
      paragraph={false}
      avatar={false}
    />
    <Skeleton
      active
      title={{ width: '85%', style: { height: '17px', borderRadius: '29px', margin: 0, padding: 0 } }}
      paragraph={false}
      avatar={false}
    />
  </div>
)

const LoadingAssistantMessage = () => (
  <div className={cx(Styles.loadingMessage, Styles.assistant)} data-testid="loading-assistant-message">
    <Skeleton
      active
      title={{ width: '95%', style: { height: '17px', borderRadius: '29px', margin: 0, padding: 0 } }}
      paragraph={false}
      avatar={false}
    />
    <Skeleton
      active
      title={{ width: '90%', style: { height: '17px', borderRadius: '29px', margin: 0, padding: 0 } }}
      paragraph={false}
      avatar={false}
    />
    <Skeleton
      active
      title={{ width: '92%', style: { height: '17px', borderRadius: '29px', margin: 0, padding: 0 } }}
      paragraph={false}
      avatar={false}
    />
    <Skeleton
      active
      title={{ width: '80%', style: { height: '17px', borderRadius: '29px', margin: 0, padding: 0 } }}
      paragraph={false}
      avatar={false}
    />
  </div>
)

export const LoadingState = ({ count = 2 }: LoadingStateProps) => {
  return (
    <>
      {Array.from({ length: count }).map((_, index) => {
        const role = index % 2 === 0 ? 'user' : 'assistant'

        return role === 'user' ? <LoadingUserMessage key={index} /> : <LoadingAssistantMessage key={index} />
      })}
    </>
  )
}
